// extracted by mini-css-extract-plugin
export var container = "_fn-1";
export var cornerButtonContainer = "_fn-6";
export var disabled = "_fn-2";
export var dragActive = "_fn-3";
export var fileContainer = "_fn-5";
export var hiddenInput = "_fn-4";
export var widthContainer = "_fn-0";